import styled from 'styled-components'

const Column = styled.div<{ gap?: string; width?: string }>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  & > *:not(:last-child) {
    margin-bottom: ${({ gap }) => gap || '0'};
  }
  ${({ width }) =>
    width &&
    `
    width: ${width};
  `}
}
`
export const ColumnCenter = styled(Column)`
  width: 100%;
  align-items: center;
`

export const AutoColumn = styled.div<{
  gap?: 'sm' | 'md' | 'lg' | string
  justify?: 'stretch' | 'center' | 'start' | 'end' | 'flex-start' | 'flex-end' | 'space-between'
}>`
  display: grid;
  grid-auto-rows: auto;
  grid-row-gap: ${({ gap }) => (gap === 'sm' && '8px') || (gap === 'md' && '12px') || (gap === 'lg' && '24px') || gap};
  justify-items: ${({ justify }) => justify && justify};
`

export default Column
